import { RAILS_POKUS } from '../utils/RailsSEOConstants';

export const { getDataAgainstPokusKey, getRailsPokusData } = (function pokusController() {
  const requestOptions = getFetchOptionsForPokusApi();
  const pokusApiUrl = RAILS_POKUS.pokusApiUrl;
  const timeoutInMilliSeconds = RAILS_POKUS.timeoutInMilliSeconds;
  const totalPokusDataKeyForLocalStorage = RAILS_POKUS.totalPokusDataKeyForLocalStorage;
  const timeOutRejectError = RAILS_POKUS.timeOutRejectError;
  const pokusFetchError = RAILS_POKUS.pokusFetchError;
  function getFetchOptionsForPokusApi() {
    const requestOptions = {
      method: RAILS_POKUS.postMethod,
      headers: {
        'Content-Type': RAILS_POKUS.contentType,
        Accept: RAILS_POKUS.contentType
      },
      body: JSON.stringify({
        lob: RAILS_POKUS.lob,
        user: {
          userId: RAILS_POKUS.userId,
          deviceId: RAILS_POKUS.deviceId
        }
      }),
      attributes: {
        deviceType: RAILS_POKUS.mobile,
        device_os: RAILS_POKUS.desktop
      }
    };
    return requestOptions;
  }

  const getRailsPokusDataFromLocalStorage = () => {
    const railsPokusData = localStorage.getItem(totalPokusDataKeyForLocalStorage);
    return railsPokusData ? railsPokusData : null;
  };

  const isExpiryTimeOver = (expiry) => {
    if (!expiry) return true;
    if (expiry < new Date().getTime()) return true;

    return false;
  };

  const setRailsPokusDataToLocalStorage = (pokusResponseJson) => {
    const expiryTime = new Date().getTime() + RAILS_POKUS.day;
    const railsPokusData = JSON.stringify({ data: pokusResponseJson, status: RAILS_POKUS.success, expiry: expiryTime });
    localStorage.setItem(totalPokusDataKeyForLocalStorage, railsPokusData);
    return railsPokusData;
  };

  const getRailsPokusApiResponsePromise = () => {
    return fetch(pokusApiUrl, requestOptions);
  };

  const rejectApiCallWithErrorPromise = () => {
    const rejectPromise = new Promise((resolve, reject) => {
      setInterval(() => {
        reject(timeOutRejectError);
      }, timeoutInMilliSeconds);
    });
    return rejectPromise;
  };

  const fetchPokusApiPromiseWithTimeOut = () => {
    const pokusDataPromise = getRailsPokusApiResponsePromise();
    const pokusFailurePromise = rejectApiCallWithErrorPromise();

    return Promise.race([pokusDataPromise, pokusFailurePromise]);
  };

  const getDataAgainstPokusKey = async (pokusKey) => {
    try {
      const pokusData = await getRailsPokusData();
      const {
        data: {
          perLobMap: {
            RAIL: { metadataValues: railsPokusMap }
          }
        }
      } = JSON.parse(pokusData);
      return railsPokusMap[pokusKey];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(pokusFetchError, error);
      clearTimeout(timeoutInMilliSeconds);
    }
  };

  const getRailsPokusData = async () => {
    try {
      let railsPokusData = getRailsPokusDataFromLocalStorage();
      const railsPokusDataJSON = JSON.parse(railsPokusData);
      if (!railsPokusData || isExpiryTimeOver(railsPokusDataJSON.expiry)) {
        const pokusResponse = await fetchPokusApiPromiseWithTimeOut();
        const pokusResponseJson = await pokusResponse.json();
        railsPokusData = setRailsPokusDataToLocalStorage(pokusResponseJson);
      }
      return railsPokusData;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(pokusFetchError, error);
      clearTimeout(timeoutInMilliSeconds);
    }
  };

  return { getDataAgainstPokusKey, getRailsPokusData };
})();
